/**
 * @flow
 * @relayHash 0a4348542e390a1c08f812c9a0ad58ee
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteIntegrationInput = {|
  id: string
|};
export type DeleteIntegrationMutationVariables = {|
  input: DeleteIntegrationInput
|};
export type DeleteIntegrationMutationResponse = {|
  +deleteIntegration: {|
    +deletedId: string
  |}
|};
export type DeleteIntegrationMutation = {|
  variables: DeleteIntegrationMutationVariables,
  response: DeleteIntegrationMutationResponse,
|};
*/


/*
mutation DeleteIntegrationMutation(
  $input: DeleteIntegrationInput!
) {
  deleteIntegration(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteIntegrationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteIntegration",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteIntegrationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteIntegrationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteIntegrationMutation",
    "id": null,
    "text": "mutation DeleteIntegrationMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ca4a6d989f00c16254999c760b835916';
module.exports = node;
